import React, { useState, useRef, useEffect } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import axios from 'helpers/api';
import * as mapYourMedsConstant from '../../../common/mapYourMedsConstant.js';

const MedRecordCategoryForm = (props) => {
    const data = props?.dataObj;
    const initialFormData = {
        id: '',
        code: '',
        facilityname: '',
        description: "",
        is_medsheet: true,
        is_treatment: true,
        is_physpres: true,
        is_active: true
    };

    const [formData, setFormData] = useState(initialFormData);
    // const [facilityoptions, setFacilityOptions] = useState([]);
    const formRef = useRef(null);
    const [buttonStatus, setButtonStatus] = useState(mapYourMedsConstant.ADD_ACTION);
    //const navigate = useNavigate();

    useEffect(() => {
        //populateData();

        if (props.edittrigger > 0) {
            //console.log(props.trigger);
            setButtonStatus(mapYourMedsConstant.UPDATE_ACTION);
            populateData();
        }

        // let results = JSON.parse(localStorage.getItem("facilitiesData"));
        // setFacilityOptions([
        //     { key: 'Select a facility', value: '' },
        //     ...results
        // ]);


    }, [props.edittrigger]);

    async function populateData() {
        // let tokenStr = localStorage.getItem("accessToken");

        // let results = JSON.parse(localStorage.getItem("facilitiesData"));
        // setFacilityOptions([
        //     { key: 'Select a facility', value: '' },
        //     ...results
        // ]);

        //if (props.medrecordcategoryid != null) {
        // await axios.get(`${process.env.REACT_APP_SERVER_URL}/patients/get-medical-record-category/` + props.medrecordcategoryid,
        //     { headers: { 'Authorization': `Bearer ${tokenStr}` } })
        //     .then((res) => {
        //         let objMedRecCatData = res.data.data;

        //         objMedRecCatData.forEach((value) => {
        //             setFormData({
        //                 code: value.code,
        //                 description: value.description,
        //                 is_medsheet: value.mar_flag ? false : true,
        //                 is_treatment: value.tar_flag ? false : true,
        //                 is_physpres: value.po_flag ? false : true,
        //             })

        //         });

        //     });
        //}

        setFormData({
            id: data.mc_id,
            code: data.code,
            description: data.description,
            is_medsheet: data.mar_flag == 'N' ? false : true,
            is_treatment: data.tar_flag == 'N' ? false : true,
            is_physpres: data.po_flag == 'N' ? false : true,
            is_active: Number(data.is_active) == 1 ? true : false
        })
    }

    const handleSubmit = async e => {
        e.preventDefault();

        let tokenStr = localStorage.getItem("accessToken");

        let pelmedsMedRecCatUrl = buttonStatus == "Add" ? `${process.env.REACT_APP_SERVER_URL}` + "/patients/add-medical-record-category" :
            `${process.env.REACT_APP_SERVER_URL}` + "/patients/update-medical-record-category";

        let pelmedsMedRecCatData = buttonStatus == "Add" ?
            {
                "group_id": localStorage.getItem("groupId") || '',
                "code": formData.code,
                "description": formData.description,
                "mar_flag": formData.is_medsheet ? 1 : 0,
                "tar_flag": formData.is_treatment ? 1 : 0,
                "po_flag": formData.is_physpres ? 1 : 0,
            } :
            {
                "id": formData.id,
                "group_id" : localStorage.getItem("groupId") || '',
                "code": formData.code,
                "description": formData.description,
                "mar_flag": formData.is_medsheet ? 1 : 0,
                "tar_flag": formData.is_treatment ? 1 : 0,
                "po_flag": formData.is_physpres ? 1 : 0,
                "is_active": formData.is_active ? 1 : 0
            }
        // console.log(pelmedsMedRecCatData)
        const { data } = await axios.post(pelmedsMedRecCatUrl, pelmedsMedRecCatData, { headers: { 'Authorization': `Bearer ${tokenStr}` } });

        if (data.status) {
            toast.success("Medical Record Category added/updated successfully", { autoClose: 3000 });
            //navigate(0);
        }
        else {
            toast.info("Error while adding Medical Record Category", { autoClose: 3000 });
        }

        //if (props.status != "Edit") {
        setFormData(initialFormData);
        formRef.current.reset();
        setButtonStatus("Add");
        //}

        props.onCallParent();
    };

    const handleFieldChange = e => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    return (
        <Form ref={formRef} onSubmit={handleSubmit}>
            {/* <Row>
                <Col>
                    <Form.Group className="mb-2">
                        <Form.Label>Facility</Form.Label>
                        <Form.Select
                            name="facilityname"
                            onChange={handleFieldChange}
                            size="sm"
                        >
                            {facilityoptions.map((option) => {
                                let isFacilitySelected = false;
                                if (props.medrecordcategoryid != null) {
                                    if (option.value == formData.facilityname) {
                                        isFacilitySelected = "selected";
                                    }
                                }
                                return (
                                    <option key={option.value} value={option.value} selected={isFacilitySelected} >
                                        {option.key}
                                    </option>
                                );
                            })}
                        </Form.Select>
                    </Form.Group>
                </Col>
            </Row> */}
            <Row>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Code</Form.Label>
                        <Form.Control
                            placeholder='Code'
                            value={formData.code}
                            size="sm"
                            name="code"
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group className="mb-3">
                        <Form.Label className="required">Description</Form.Label>
                        <Form.Control
                            placeholder='Description'
                            size="sm"
                            value={formData.description}
                            name="description"
                            onChange={handleFieldChange}
                            type="text"
                        />
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mb-1">
                <Col>
                    <Form.Check
                        type='switch'
                        name="is_medsheet"
                        id='is_medsheet'
                        checked={
                            formData.is_medsheet
                        }
                        onChange={e =>
                            setFormData({
                                ...formData,
                                is_medsheet: e.target.checked
                            })
                        }
                        label='Medsheet'
                    />
                </Col>
                <Col>
                    <Form.Check
                        type='switch'
                        name="is_treatment"
                        id='is_treatment'
                        checked={
                            formData.is_treatment
                        }
                        onChange={e =>
                            setFormData({
                                ...formData,
                                is_treatment: e.target.checked
                            })
                        }
                        label='Treatment'
                    />
                </Col>
                <Col>
                    <Form.Check
                        type='switch'
                        name="is_physpres"
                        id='is_physpres'
                        checked={
                            formData.is_physpres
                        }
                        onChange={e =>
                            setFormData({
                                ...formData,
                                is_physpres: e.target.checked
                            })
                        }
                        label='Physician Prescription'
                    />
                </Col>
            </Row>

            <Row>
                <Col xs={6}>
                    <Form.Group>
                        <Button
                            type="submit"
                            color="primary"
                            className="mt-1 w-50"
                            size="sm"
                            disabled={!formData.code || !formData.description}>
                            {buttonStatus}
                        </Button>
                    </Form.Group>
                </Col>
            </Row>
            <Row className="mt-2">
                <Col>
                    <Form.Label><span className="text-danger">*</span> indicates required field</Form.Label>
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    <Form.Check
                        type='switch'
                        id='is_active'
                        name="is_active"
                        checked={
                            formData.is_active
                        }
                        onChange={e =>
                            setFormData({
                                ...formData,
                                is_active: e.target.checked
                            })
                        }
                        label='Active'
                    />
                </Col>
            </Row>
        </Form>
    );
};
export default MedRecordCategoryForm;

